import styled, { css } from 'styled-components';
import {
  TituloH1 as TituloPrincipal,
  Sorriso as IconSorriso,
  Descricao,
} from '../../../../components/TituloSorriso/styles';
import { media } from '../../../../layouts/utils';
import { colorBrandPrimary, fontFamily } from 'src/global.style';

export const Sorriso = styled(IconSorriso)`
  margin-bottom: 0;
`;

export const TextWrap = styled.div`
  padding: 40px 20px 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #EDEDED;
`;

export const Title = styled(TituloPrincipal)`
  font-weight: bold;
  color: ${colorBrandPrimary.verdeTaverna};
  ${media.desktop`
    max-width: 100%;
    line-height: 28px;
    font-size: 32px;
  `}
  font-size: 32px;
  padding: 0;
  text-align: center;
  max-width: 300px;
  margin-bottom: 10px;
  line-height: 45px;
`;

export const Text = styled(Descricao)`
  ${media.phone`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  `}
  ${media.tablet`
    max-width: 85%;
  `}
  max-width: 50%;
  padding: 0;
  text-align: center;
  margin-top: 16px;
  color: ${colorBrandPrimary.verdeTaverna};
  font-weight: 500;
`;

export const Link = styled.a`
  text-decoration: none;
  ${({ disabled }) => disabled && `cursor: not-allowed; pointer-events: none;`}
  margin-top: 32px;
`;

const buttonEnabled = css`
  cursor: pointer;
  color: ${({ color }) => color};
  &:hover {
    margin-right: -0.5rem;
    min-width: 10rem;
    padding: 1rem 2.25rem;
    transition: 0.2s;
    transform: translateY(-0.25rem);
  }
`;

const buttonDisabled = css`
  cursor: not-allowed;
  background: ${({ backgroundColor }) => backgroundColor} !important;
  color: ${({ color }) => color};
  opacity: 0.6;
`;

export const Button = styled.div`
  user-select: none;
  height: 49px;
  min-width: 156px;
  padding: 0.9rem 2rem;
  font-family: ${fontFamily.neutral};
  font-weight: bold;
  font-size: 1rem;
  transition: all 0.1s ease-in 0s;
  border-radius: 9999px;
  text-align: center;
  color: ${colorBrandPrimary.marine};
  background: #00FF5F;
  ${({ disabled }) => (disabled ? buttonDisabled : buttonEnabled)}
`;
